<template>
  <v-row>
    <v-col class="col-12">
      <h2 v-if="currentApplication.rejectionReason">Feedback</h2>
      <Note
        :text="currentApplication.rejectionReason"
        isSelf
        v-if="currentApplication.rejectionReason"
      />
    </v-col>
    <v-col class="col-12">
      <h2 class="mb-3">Application Questions</h2>
      <ApplicationQuestionsWithAnswers
        :applicationId="currentApplication.id"
        :bookingId="currentApplication.booking.id"
      />
    </v-col>
  </v-row>
</template>
<script>
import Note from "@/components/common/Notes/Note";
import ApplicationQuestionsWithAnswers from "@/components/workers/ApplicationQuestionsWithAnswers";

export default {
  name: "ApplicationDetails",
  components: {
    Note,
    ApplicationQuestionsWithAnswers
  },
  props: {
    currentApplication: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss"></style>
